<app-header></app-header>
<div class="app-body">
  <app-sidebar></app-sidebar>
  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <app-breadcrumbs></app-breadcrumbs>

    <div class="px-2">
      <router-outlet></router-outlet>
    </div>

  </main>
</div>
<app-footer></app-footer>
